var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelmetDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1V6",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22228 3.92603C6.24085 4.21866 5.33757 4.75181 4.60028 5.48911C3.43339 6.656 2.77783 8.23865 2.77783 9.88888L15.2223 9.88888C15.2223 8.23865 14.5667 6.656 13.3998 5.48911C12.6625 4.75181 11.7593 4.21866 10.7778 3.92603V6.5185C10.7778 7.3367 9.98189 7.99998 9.00005 7.99998C8.01821 7.99998 7.22228 7.3367 7.22228 6.5185V3.92603Z",
    stroke: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 9.77777,
    width: 2.66667,
    height: 16,
    rx: 1.33333,
    transform: "rotate(90 17 9.77777)",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelmetDark);
export default __webpack_public_path__ + "static/media/helmet-dark.6858aeec.svg";
export { ForwardRef as ReactComponent };